<div
  class="flex items-start gap-3 px-4 py-3 border-b border-slate-100 cursor-pointer transition-colors hover:bg-slate-50"
>
  <span
    class="w-2 h-2 rounded-full mt-1.5 flex-shrink-0"
    [ngClass]="abierto ? 'bg-transparent' : 'bg-primary'"
  ></span>
  <div class="min-w-0 flex-1">
    <p
      class="text-sm truncate"
      [ngClass]="abierto ? 'font-medium text-slate-700' : 'font-semibold text-slate-900'"
    >
      {{ titulo }}
    </p>
    <p class="text-xs text-slate-500 truncate">{{ cuerpo }}</p>
    <p class="text-xs text-slate-400 mt-1">{{ fecha | date: "dd/MM/yyyy" }}</p>
  </div>
</div>
